"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IconNames", {
  enumerable: true,
  get: function get() {
    return _icons.IconNames;
  }
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = _interopRequireDefault(require("ui-box"));

var _icons = require("@blueprintjs/icons");

var _theme = require("../../theme");

/* eslint react/no-array-index-key: 0, eqeqeq: 0, no-eq-null: 0 */

/**
 * This implementation is a remix of the Icon component in Blueprintjs:
 * https://github.com/palantir/blueprint/blob/813e93f2/packages/core/src/components/icon/icon.tsx#L15
 * Refer to the LICENSE for BlueprintJS here: https://github.com/palantir/blueprint/blob/develop/LICENSE
 */
var Icon =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Icon, _PureComponent);

  function Icon() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Icon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Icon)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSvgPaths", function (pathsSize, iconName) {
      var svgPathsRecord = pathsSize === Icon.SIZE_STANDARD ? _icons.IconSvgPaths16 : _icons.IconSvgPaths20;
      var pathStrings = svgPathsRecord[iconName];

      if (pathStrings == null) {
        return null;
      }

      return pathStrings.map(function (d, i) {
        return _react.default.createElement("path", {
          key: i,
          d: d,
          fillRule: "evenodd"
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          color = _this$props.color,
          icon = _this$props.icon,
          size = _this$props.size,
          title = _this$props.title,
          svgProps = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "color", "icon", "size", "title"]);
      var _this$props$style = this.props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style;

      if (icon == null) {
        return null;
      }

      if (typeof icon !== 'string') {
        return icon;
      } // Choose which pixel grid is most appropriate for given icon size


      var pixelGridSize = size >= Icon.SIZE_LARGE ? Icon.SIZE_LARGE : Icon.SIZE_STANDARD;
      var paths = this.renderSvgPaths(pixelGridSize, icon);

      if (paths == null) {
        return null;
      }

      var viewBox = "0 0 ".concat(pixelGridSize, " ").concat(pixelGridSize);

      if (color != null) {
        style = (0, _objectSpread2.default)({}, style, {
          fill: theme.getIconColor(color)
        });
      }

      return _react.default.createElement(_uiBox.default, (0, _extends2.default)({
        is: "svg"
      }, svgProps, {
        style: style,
        "data-icon": icon,
        width: size,
        height: size,
        viewBox: viewBox
      }), title ? _react.default.createElement("title", null, title) : null, paths);
    }
  }]);
  return Icon;
}(_react.PureComponent);

Icon.displayName = "Icon";
(0, _defineProperty2.default)(Icon, "SIZE_STANDARD", 16);
(0, _defineProperty2.default)(Icon, "SIZE_LARGE", 20);
(0, _defineProperty2.default)(Icon, "propTypes", {
  /**
   * Color of icon. Equivalent to setting CSS `fill` property.
   */
  color: _propTypes.default.string,

  /**
   * Name of a Blueprint UI icon, or an icon element, to render.
   * This prop is required because it determines the content of the component, but it can
   * be explicitly set to falsy values to render nothing.
   *
   * - If `null` or `undefined` or `false`, this component will render nothing.
   * - If given an `IconName` (a string literal union of all icon names),
   *   that icon will be rendered as an `<svg>` with `<path>` tags.
   * - If given a `JSX.Element`, that element will be rendered and _all other props on this component are ignored._
   *   This type is supported to simplify usage of this component in other Blueprint components.
   *   As a consumer, you should never use `<Icon icon={<element />}` directly; simply render `<element />` instead.
   */
  icon: _propTypes.default.string.isRequired,

  /**
   * Size of the icon, in pixels.
   * Blueprint contains 16px and 20px SVG icon images,
   * and chooses the appropriate resolution based on this prop.
   */
  size: _propTypes.default.number.isRequired,

  /**
   * Description string.
   * Browsers usually render this as a tooltip on hover, whereas screen
   * readers will use it for aural feedback.
   * By default, this is set to the icon's name for accessibility.
   */
  title: _propTypes.default.string,

  /**
   * CSS style properties.
   */
  style: _propTypes.default.object,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(Icon, "defaultProps", {
  size: 16,
  color: 'currentColor'
});

var _default = (0, _theme.withTheme)(Icon);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/icon/src/Icon.js
// module id = 161
// module chunks = 0